"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bookmarkBriefcase = exports.fetchBriefcases = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/briefcase/list");
const Actions = require("../../actions/briefcase/list");
const sok_types_1 = require("@caddigital/sok-types");
const errorHandling_1 = require("../../utils/errorHandling");
function fetchBriefcases(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/briefcase/${action.project !== undefined ? `project/${action.project}` : ''}`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        return t
            .array(sok_types_1.Briefcase.iBriefcase)
            .decode(xhr.response)
            .fold((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseValidationError)(error), action.project)), (cases) => (0, rxjs_1.of)(Actions.fetchSuccess(cases, action.project)));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(error), action.project))))));
}
exports.fetchBriefcases = fetchBriefcases;
function bookmarkBriefcase(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.BOOKMARK_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'PUT',
        body: { status: action.payload.status },
        url: `${baseUrl}api/briefcase/${action.payload.briefcase.id}/bookmark`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        return sok_types_1.Briefcase.iBriefcase
            .decode(xhr.response)
            .fold((error) => (0, rxjs_1.of)(Actions.bookmarkFailed((0, errorHandling_1.parseValidationError)(error), action.payload.briefcase, action.project)), (cases) => (0, rxjs_1.of)(Actions.bookmarkSuccess(cases, action.project)));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.bookmarkFailed((0, errorHandling_1.parseAjaxErrorResponse)(error), action.payload.briefcase, action.project))))));
}
exports.bookmarkBriefcase = bookmarkBriefcase;
//# sourceMappingURL=list.js.map